import { AccountDetailsPage } from '@/components/account-details-page';

// TODO: unnecessary layer of abstraction, just move component logic into this file.
const AccountDetails: React.FC = () => (
  <AccountDetailsPage />
);

export default AccountDetails;
